import React, { Component } from 'react'
import { Form } from 'react-bootstrap'
import {Link, NavLink} from 'react-router-dom'
import './style.css'

export class Blog extends Component {
    render() {
        return (
            <div>
                
  <div className="section is-hero has-gradient position-relative overflow-hidden is-subpage">
    <div className="container position-relative">
      <div className="col block-centered text-align-center lg-7 md-12">
        <h1>Blog</h1>
      </div>
    </div><img src="images/header2.svg" alt="" className="header-image style2" /></div>
  <div className="section">
    <div className="container is-wrapping">
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/gratisography-412H.jpg" sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">Why Your Relationship Today Is Less Likely To Work</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/gratisography-417H.jpg" sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">Proof of Transcoding as a New Consensus Mechanism</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/gratisography-handclap.jpg"  sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">Silicon Valley: Building on a Culture of Looking Forward</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/gratisography-tape-face.jpg"  sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">Three Threats Posed by Deepfakes That Technology Won’t Solve</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/gratisography-278H.jpg" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">Microsoft’s Surface ‘Right to Repair’ Is Actually Working</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/gratisography-346H.jpg"  sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">Warren, Yang, Zuckerberg, and the Future of Big Tech</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/gratisography-300H.jpg"  sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">How to Get the Best Android 10 Features on Older Phones</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/gratisography-358H.jpg" sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">From a Single Decision Tree to a Random Forest theme</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><a href="single-post.html" className="c-gridpost__image w-inline-block"><img src="images/2126.jpg"  sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" /></a>
          <div className="c-gridpost__category style3"><a href="#" className="c-gridpost__category-link">Design</a> / <a href="#" className="c-gridpost__category-link">Technology</a></div>
          <a href="#" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">Learn how they work before you need to use them</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="col lg-12">
        <div className="c-paging">
          <div className="iconfont margin-right-small is-11px"><em className="iconfont__no-italize"></em></div>
          <div className="c-paging__number is-dark is-rounded on-dark">1</div><a href="#" className="c-paging__number">2</a><a href="#" className="c-paging__number">3</a><a href="#" className="c-paging__number">4</a><a href="#" className="c-paging__number">5</a><a href="#" className="c-paging__number">6</a><a href="#" className="c-paging__number">7</a>
          <div className="c-paging__number">...</div><a href="#" className="c-paging__number">99</a><a href="#" className="iconfont margin-left-small is-11px"><em className="iconfont__no-italize"></em></a></div>
      </div>
    </div>
  </div>
 
            </div>
        )
    }
}

export default Blog